import React, {useEffect, Component, Fragment, useState} from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from 'highcharts/highcharts-more'
import { AlarmColor } from "../../../datas/ColorData";
import { FxmsEvent } from "../../../actions/FxEvent";
import { FxmsData } from "../../../datas/FxData";
import { DateUtil } from "../../../datas/DateUtil";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {DataSelecter} from "./DataSelecter";
import Button from "@mui/material/Button";

HighchartsMore(Highcharts)

export const FxRtGuageChart = (props) => {


  const [title, setTitle] = useState('')
  const [titleSensor, setTitleSensor] = useState("");
  const [titlePsItem, setTitlePsItem] = useState("");
  //list
  const [sensorList, setSensorList] = useState(props.sensorList)
  const [psItemList, setPsItemList] = useState(props.psItemList)
  //selected
  const [psItem, setPsItem] = useState('');
  const [sensor, setSensor] = useState('');

  const [ranges, setRanges] = useState([]);
  const [averages, setAverages] = useState([]);
  const [intervalId, setIntervalId] = useState(null);

  //ws
  const [socket, setSocket] = useState(null)
  //chart
  const [yAxis, setYAxis] = useState('')
  const [unit, setUnit] = useState('')
  const [datas, setDatas] = useState(0)
  const [minVal, setMinVal] = useState(0)
  const [maxVal, setMaxVal] = useState(100)
  const [plotBands, setPlotBands] = useState([
    {from: parseInt((maxVal - minVal) * .5 + minVal), to: parseInt((maxVal - minVal) * .6 + minVal), color: AlarmColor.warning },
    {from: parseInt((maxVal - minVal) * .6 + minVal), to: parseInt((maxVal - minVal) * .7 + minVal), color: AlarmColor.minor },
    {from: parseInt((maxVal - minVal) * .7 + minVal),to: parseInt((maxVal - minVal) * .8 + minVal),  color: AlarmColor.major },
    {from: parseInt((maxVal - minVal) * .8 + minVal), to: maxVal, color: AlarmColor.critical }
  ])

  useEffect(() => {
    if(props.item.fxUiDashbItemAttrs){
      if(props.item.fxUiDashbItemAttrs.length > 0) {
        setTitle(props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title').attrVal:'')
        let tempSensor = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor').attrVal : ''
        let tempPsItem = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem').attrVal : ''
        if(tempSensor != ''){
          handleSensorChange({target:{value:parseInt(tempSensor)}})
        }
        if(tempPsItem != ''){
          handlePsItemChange({target:{value:tempPsItem}})
        }
      }
    }

  }, []);
  const showDatas = (sensorId,psId) => {
    if(socket){
      socket.close(1000,'change item')
    }
    const host = FxmsData.getVarValue("fxms-value-peeker-host", "10.0.1.11");
    const port = FxmsData.getVarValue("fxms-value-peeker-port", 63819);
    let ws = new WebSocket("ws://"+ host + ':' + port);
    ws.onopen =  (e) => {
      let map = { jwt : FxmsData.getJWT() };
      let sendStr = JSON.stringify(map);
      let sendStr2 = JSON.stringify({ action: 'add', moNo: sensorId, psId: psId });
      ws.send(sendStr);
      ws.send(sendStr2)
      setSocket(ws)
    };
    ws.onmessage = (e) => {
      let recvObj = JSON.parse(e.data);
      if (recvObj.eventType === 'SessionVo') {
      }else{
        setDatas(recvObj.value)
      }
    };
    ws.onclose = (event) => {
      setSocket(null)
      if (event.wasClean) {
        console.log(`커넥션이 정상적으로 종료되었습니다(code=${event.code} reason=${event.reason})`);
      } else {
        alert('[close] 커넥션이 죽었습니다.');
      }
    };
    ws.onerror = (error) => {
      alert(`서버 통신오류`);
    };
  }
  const getData = (id,name) => {
    if(name === "sensor"){
      showDatas(id,psItem)
    }else if(name === "psItem"){
      showDatas(sensor,id)
    }

  }
  const handleSensorChange = (e) => {
    setSensor(e.target.value)
    setTitleSensor(sensorList.find(x=>x.moNo===e.target.value).moDispName)
    if(psItem != ''){
      getData(e.target.value,'sensor')
    }
  }
  const handlePsItemChange = (e) => {
    setPsItem(e.target.value)
    if(psItemList.find(x=>x.psId===e.target.value)){
      setMinVal(psItemList.find(x=>x.psId===e.target.value).minVal)
      setMaxVal(psItemList.find(x=>x.psId===e.target.value).maxVal)
      setTitlePsItem(psItemList.find(x=>x.psId===e.target.value).psName)
      setUnit(psItemList.find(x=>x.psId===e.target.value).psUnit)
    }
    if(sensor != ''){
      getData(e.target.value,'psItem')
    }
  }
  const handleTitleChange = (e) => {
    setTitle(e.target.value)
  }
  const saveCurrentData = () => {
    let currentData = []
    currentData.push({uiNo:props.item.uiNo,attrName:'title',attrVal:title,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'psItem',attrVal:psItem,attrType:'string'})
    currentData.push({uiNo:props.item.uiNo,attrName:'sensor',attrVal:sensor,attrType:'string'})
    props.save(currentData,props.item.uiNo,props.item.opId)
  }
  const removeItem = () => {
    props.removeItem(props.item.uiNo)
  }
    return (
      <>
        {props.editable ? <DataSelecter mode={'guage'} sensorList={sensorList} sensor={sensor} psItem={psItem} psItemList={psItemList} handleCloseAndSave={saveCurrentData} handleTitleChange={handleTitleChange} handleSensorChange={handleSensorChange} handlePsItemChange={handlePsItemChange} removeItem={removeItem} />: '' }
        <HighchartsReact
            className="HighChart"
            highcharts={Highcharts}
            containerProps={{ style: { width: "100%", height: "100%" } }}
            options={{
              chart: {
                type: 'gauge',
                backgroundColor: 'rgba(255,255,255, 0.1)',
                plotBackgroundColor: 'rgba(255,255,255, 0.1)',
                plotBorderWidth: 0,
                plotShadow: false,
              },

              title: {text: title, style: { color: 'white' }},
              subtitle: {text: titleSensor+" :: "+titlePsItem, style: { color: "white" },},
              pane: {startAngle: -150, endAngle: 150,
                background: [
                  {backgroundColor:
                        {linearGradient: {x1: 0,y1: 0,x2: 0, y2: 1}, stops: [[0, '#FFF'], [1, '#333']]},
                    borderWidth: 0, outerRadius: '109%'},
                  {backgroundColor: {linearGradient: {x1: 0, y1: 0, x2: 0, y2: 1}, stops: [[0, '#333'], [1, '#FFF']]}, borderWidth: 1, outerRadius: '107%'},
                  {backgroundColor: '#DDD', borderWidth: 0, outerRadius: '105%', innerRadius: '103%'}]},
              // the value axis
              yAxis: {
                min: minVal,
                max: maxVal,
                minorTickInterval: 'auto',
                minorTickWidth: 1,
                minorTickLength: 10,
                minorTickPosition: 'inside',
                minorTickColor: '#666',
                tickPixelInterval: 30,
                tickWidth: 2,
                tickPosition: 'inside',
                tickLength: 10,
                tickColor: '#666',
                labels: {step: 2, rotation: 'auto'},
                title: {text: unit},
                plotBands: plotBands},
              series: [{
                name: titlePsItem,
                data: [datas],
                tooltip: {valueSuffix: ' ' + unit}
              }]
            }} />
      </>
    );
}

